export default "__VITE_ASSET__Wg923nz9__"